import { createContext, useContext } from "react";

type CompanyDocumentTreeDndState = {
  /** Что подсветить: узел папки-приёмника или звено корня. */
  dropTargetKey?: string;
  /** Идёт перенос — новый начинать нельзя, пока дерево не перечитано. */
  moving: boolean;
};

/**
 * Состояние перетаскивания для строк дерева. Строки читают его сами, а не получают
 * пропом: так смена цели перерисовывает только их, а не всё antd-дерево.
 */
export const CompanyDocumentTreeDndContext =
  createContext<CompanyDocumentTreeDndState>({ moving: false });

export function useCompanyDocumentTreeDndState() {
  return useContext(CompanyDocumentTreeDndContext);
}
